module.exports = __webpack_public_path__ + "static/media/front_porch_dining_780x390.9263a147.jpg";